// @flow
import type { Action, Client, GetState, NetPublishSite } from 'state/types';
import {
  DELETE_NP_SITE,
  DELETE_NP_SITE_SUCCESS,
  DELETE_NP_SITE_FAIL,
  GET_NP_SITES,
  GET_NP_SITES_FAIL,
  GET_NP_SITES_SUCCESS,
  GET_NP_SERVER_STATUS,
  GET_NP_SERVER_STATUS_FAIL,
  GET_NP_SERVER_STATUS_SUCCESS,
  SET_NP_SITE_ENABLED,
  SET_NP_SITE_ENABLED_SUCCESS,
  SET_NP_SITE_ENABLED_FAIL,
  type NetPublishState,
} from 'state/types/netPublishTypes';

import { API } from 'util/constants';

const initialState: NetPublishState = {
  sites: [],
  status: {},
};

export default function reducer(
  state: NetPublishState = initialState,
  action: Action
) {
  switch (action.type) {
    case GET_NP_SITES_SUCCESS:
      return {
        ...state,
        sites: (action.payload
          .filter(site => !site.isPreview)
          .sort((a, b) =>
            a.siteName.localeCompare(b.siteName)
          ): NetPublishSite[]),
      };
    case GET_NP_SERVER_STATUS_SUCCESS:
      return {
        ...state,
        status: action.payload,
      };
    default:
      return state;
  }
}

function getSites(identitySession: string) {
  return {
    types: [GET_NP_SITES, GET_NP_SITES_SUCCESS, GET_NP_SITES_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/netpublish/site`, {
        params: { session: identitySession },
      }),
  };
}

function getNPServerStatus(identitySession: string) {
  return {
    types: [
      GET_NP_SERVER_STATUS,
      GET_NP_SERVER_STATUS_SUCCESS,
      GET_NP_SERVER_STATUS_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.get(`${API}/netpublish/server/status`, {
        params: { session: identitySession },
      }),
  };
}

function setSiteEnabled(
  identitySession: string,
  siteId: string,
  isEnabled: boolean
) {
  return {
    types: [DELETE_NP_SITE, DELETE_NP_SITE_SUCCESS, DELETE_NP_SITE_FAIL],
    promise: (client: Client, getState: GetState) =>
      client.put(`${API}/netpublish/site/${siteId}/setEnabled`, {
        params: { session: identitySession, enabled: isEnabled },
      }),
  };
}

function deleteSite(identitySession: string, siteId: string) {
  return {
    types: [
      SET_NP_SITE_ENABLED,
      SET_NP_SITE_ENABLED_SUCCESS,
      SET_NP_SITE_ENABLED_FAIL,
    ],
    promise: (client: Client, getState: GetState) =>
      client.delete(`${API}/netpublish/site/${siteId}`, {
        params: { session: identitySession },
      }),
  };
}

export const actions = {
  deleteSite,
  getSites,
  getNPServerStatus,
  setSiteEnabled,
};



// WEBPACK FOOTER //
// ./src/state/reducers/netPublishReducer.js